module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/headquarters/hq-grid-4-large-a80647a237fef6e7817a1fe62e25e3be.jpg";